"use client";

import { ChevronLeft } from "lucide-react";
import { useRouter } from "next/navigation";

const Breadcrumb = ({ items }: { items: { route?: string; title: string }[] }) => {
  const router = useRouter();

  const handleNavigation = (route: string) => {
    if (route) router.push(route);
  };

  return (
    <div
      dir="rtl"
      className="flex items-center gap-2 mb-3 bg-white px-3 py-2 rounded-lg text-sm"
    >
      {items.map((item: any, index: number) => (
        <div key={item.title} className="flex items-center gap-1.5">
          {item.route ? (
            <button
              type="button"
              onClick={() => handleNavigation(item.route)}
              className="text-brand-700 whitespace-nowrap hover:cursor-pointer text-sm transition-colors hover:text-[#0055AA]"
            >
              {item.title}
            </button>
          ) : (
            <span className="text-gray-800 whitespace-nowrap text-sm">
              {item.title}
            </span>
          )}

          {index < items.length - 1 && (
            <ChevronLeft size={14} className="text-gray-400" />
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
